import { render } from "./Loading.vue?vue&type=template&id=b990c3da&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=b990c3da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b990c3da"]])

export default __exports__